export class ApiError extends Error {
  readonly status: number
  readonly details: unknown
  readonly method: string
  readonly url: string

  constructor(status: number, message: string, details: unknown, method: string, url: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.details = details
    this.method = method
    this.url = url
  }
}

export const isApiError = (err: unknown): err is ApiError => err instanceof ApiError

export const isAbortError = (err: unknown): err is DOMException =>
  err instanceof DOMException && err.name === 'AbortError'

export const isChunkLoadError = (err: unknown): boolean => {
  if (!err) return false
  const name = (err as Error).name
  const message = (err as Error).message ?? ''
  return (
    name === 'ChunkLoadError' ||
    /Loading chunk [\d]+ failed/.test(message) ||
    /Failed to fetch dynamically imported module/.test(message) ||
    /Importing a module script failed/.test(message)
  )
}
